var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richtext"},[(typeof _vm.text === 'object' && _vm.text)?_c('rich-text-renderer',{attrs:{"document":_vm.text}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }